module.exports = __webpack_public_path__ + "img/mobilelab_driving.b73ae249.svg";